export const UNKNOWN = 'UNKNOWN';
export const PAYMENTS_LOADED_PENDING = 'payments_loaded_pending';
export const PAYMENTS_LOADED_FAILED = 'payments_loaded_failed';
export const PAYMENTS_LOADED_DONE = 'payments_loaded_done';
